import { combineReducers } from 'redux';

import flashcardHeaders from './flashcardHeaders';

import flashcards from './flashcards';

import flashcard from './flashcard';

import flashcardBody from './flashcardBody';

import flashcardTypes from './flashcardTypes';

import trainings from './trainings';

import tests from './tests';

export const reducers = combineReducers({
  flashcard,
  flashcardBody,
  flashcardHeaders,
  flashcards,
  flashcardTypes,
  trainings,
  tests,
});
